<template>
  <div class="dragonBoat" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.dragonBoat.background.pictureUrl})`}">
    <div class="title" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.dragonBoat.title.pictureUrl})`}"></div>
    <div class="btn rulesBtn" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.dragonBoat.rulesBtn.pictureUrl})`}"></div>
    <div class="btn myPrize" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.dragonBoat.myPrize.pictureUrl})`}"></div>
    <div class="start" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.dragonBoat.start.pictureUrl})`}"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('market', ['marketingActivityData', 'cover'])
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.dragonBoat{
  height: 682px;
  background-size: 100% 100%;
  background-position: top 24px center;
  position: relative;
  *{
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: absolute;
  }
  .title{
    width: 170px;
    height: 218px;
    position: absolute;
    left: 0;
    right: 0;
    top: 94px;
    margin: auto;
  }
  .rulesBtn,.myPrize{
    width: 50px;
    height: 55px;
    position: absolute;
    right: 10px;
  }

  .rulesBtn{
    top: 124px;
  }
  .myPrize{
    top: 194px;
  }
  .start{
    width: 200px;
    height: 84px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 24px;
  }
}
</style>
